// extracted by mini-css-extract-plugin
var _1 = "EmailProfileActionsWidget-moduleactionsContent__R3YIn WidgetContentContainer-moduleWidgetContentContainer__HxIkI";
export { _1 as "actionsContent" }
